import { chartsData } from './charts-view';
import { tableData } from './table-view';

export const appointmentsDemoData = {
  chartsData,
  tableData,
};
